import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ICardHeaderProps } from './interface';
import { withCard } from './with-card';

export const withCardHeader =
  <T extends object>(Component: React.FC<any>) =>
  (props: T & ICardHeaderProps) => {
    if (!props.title) return <Component {...props} />;

    const Content = () => {
      if (!props.headerActions)
        return (
          <>
            <Title {...props} />

            <Component {...props} />
          </>
        );

      return (
        <>
          <Stack
            direction="row"
            gap={1}
            justifyContent="space-between"
            alignItems="start"
          >
            <Title {...props} />

            {props.headerActions}
          </Stack>

          <Component {...props} />
        </>
      );
    };

    return withCard(Content)(props);
  };

export const Title = ({
  title,
  subTitle,
  titleVariant = 'body1',
  UiTooltip,
  titleFontWeight = 500,
}: Partial<ICardHeaderProps>) => {
  if (!subTitle)
    return (
      <Stack direction="row" alignItems="center" gap={0.5} mb={1}>
        <Typography
          variant={titleVariant}
          component="h2"
          fontWeight={titleFontWeight}
        >
          {title}
        </Typography>
        {UiTooltip}
      </Stack>
    );

  return (
    <Stack direction="column" mb={1}>
      <Stack direction="row" alignItems="start" gap={0.5}>
        <Typography
          variant={titleVariant}
          component="h2"
          fontWeight={titleFontWeight}
        >
          {title}

          {UiTooltip}
        </Typography>
      </Stack>
      <Typography variant="body2" component="p">
        {subTitle}
      </Typography>
    </Stack>
  );
};
